import { createSlice } from "@reduxjs/toolkit";

const searchResSlice = createSlice({
  name: "searchResults",
  initialState: [],
  reducers: {
    addMovieResults(state, action) {
      state.length = 0;
      action.payload.map((movie) => {
        state.push(movie);
      });
    },
    clearSearchResults(state) {
      state.length = 0;
    },
  },
});

export const { addMovieResults, clearSearchResults } = searchResSlice.actions;
export default searchResSlice.reducer;
